// Tabelas do eSocial (leiaute S-1.3, Anexo I) usadas no envio. Valores conforme os XSD oficiais.

export const CATEGORIAS = [
  {
    value: 101,
    text: "101 - Empregado - Geral, inclusive empregado público da administração direta ou indireta contratado pela CLT",
  },
  {
    value: 102,
    text: "102 - Empregado - Trabalhador rural por pequeno prazo (Lei 11.718/2008)",
  },
  { value: 103, text: "103 - Empregado - Aprendiz" },
  { value: 105, text: "105 - Empregado - Contrato a termo (Lei 9.601/1998)" },
  { value: 106, text: "106 - Trabalhador temporário (Lei 6.019/1974)" },
  { value: 111, text: "111 - Empregado - Contrato de trabalho intermitente" },
  {
    value: 301,
    text: "301 - Servidor público titular de cargo efetivo, magistrado, ministro/conselheiro de Tribunal de Contas e membro do MP",
  },
  {
    value: 302,
    text: "302 - Servidor público ocupante de cargo exclusivo em comissão",
  },
  { value: 303, text: "303 - Exercente de mandato eletivo" },
  {
    value: 306,
    text: "306 - Servidor público contratado por tempo determinado (regime administrativo especial)",
  },
  { value: 307, text: "307 - Militar dos Estados e Distrito Federal" },
  { value: 309, text: "309 - Agente público - Outros" },
  { value: 310, text: "310 - Servidor público eventual" },
  { value: 312, text: "312 - Auxiliar local" },
  { value: 314, text: "314 - Militar das Forças Armadas" },
];

export const TIPOS_JORNADA = [
  { value: 2, text: "12 x 36 (12 horas de trabalho e 36 de descanso)" },
  { value: 3, text: "Horário diário fixo e folga variável" },
  { value: 4, text: "Horário diário fixo e folga fixa no domingo" },
  { value: 5, text: "Horário diário fixo e folga fixa exceto no domingo" },
  {
    value: 6,
    text: "Horário diário fixo, folga fixa em outro dia e folga periódica no domingo",
  },
  { value: 7, text: "Turno ininterrupto de revezamento" },
  { value: 9, text: "Demais tipos de jornada" },
];

// O código 1 (25 horas) só vale para doméstico, não enviado por este sistema.

export const TEMPOS_PARCIAIS = [
  { value: 0, text: "Não é tempo parcial" },
  { value: 2, text: "Limitado a 30 horas semanais" },
  { value: 3, text: "Limitado a 26 horas semanais" },
];

export const REGIMES_PREVIDENCIA = [
  { value: 1, text: "RGPS - Regime Geral" },
  {
    value: 2,
    text: "RPPS, Regime dos Parlamentares ou Militares dos Estados/DF",
  },
  { value: 3, text: "Previdência social no exterior" },
  {
    value: 4,
    text: "Sistema de Proteção Social dos Militares das Forças Armadas",
  },
];

export const TIPOS_PROVIMENTO = [
  { value: 1, text: "Nomeação em cargo efetivo" },
  { value: 2, text: "Nomeação exclusivamente em cargo em comissão" },
  { value: 3, text: "Incorporação ou matrícula (militar)" },
  { value: 5, text: "Redistribuição ou reforma administrativa" },
  { value: 6, text: "Diplomação" },
  { value: 7, text: "Contratação por tempo determinado" },
  { value: 8, text: "Remoção" },
  { value: 9, text: "Designação" },
  { value: 11, text: "Estabilizados - art. 19 do ADCT" },
  { value: 99, text: "Outros" },
];

export const PLANOS_RPPS = [
  { value: 0, text: "Sem segregação da massa" },
  { value: 1, text: "Fundo em capitalização" },
  { value: 2, text: "Fundo em repartição" },
  { value: 3, text: "Mantido pelo Tesouro" },
];

export const MODALIDADES_APRENDIZ = [
  {
    value: 1,
    text: "Contratação direta (pelo estabelecimento cumpridor da cota)",
  },
  {
    value: 2,
    text: "Contratação indireta (por entidade sem fins lucrativos ou de prática desportiva)",
  },
];

export const HIPOTESES_TEMPORARIO = [
  { value: 1, text: "Substituição transitória de pessoal permanente" },
  { value: 2, text: "Demanda complementar de serviços" },
];

export const TIPOS_INSCRICAO = [
  { value: 1, text: "CNPJ" },
  { value: 2, text: "CPF" },
];

export const TIPOS_INSCRICAO_LOCAL = [
  { value: 1, text: "CNPJ" },
  { value: 3, text: "CAEPF" },
  { value: 4, text: "CNO" },
];

export const TEMPOS_RESIDENCIA = [
  { value: 1, text: "Prazo indeterminado" },
  { value: 2, text: "Prazo determinado" },
];

export const CONDICOES_INGRESSO = [
  { value: 1, text: "Refugiado" },
  { value: 2, text: "Solicitante de refúgio" },
  { value: 3, text: "Permanência no Brasil por reunião familiar" },
  { value: 4, text: "Beneficiado pelo acordo entre países do Mercosul" },
  {
    value: 5,
    text: "Dependente de agente diplomático/consular com acordo de reciprocidade",
  },
  { value: 6, text: "Beneficiado pelo Tratado de Amizade Brasil-Portugal" },
  { value: 7, text: "Outra condição" },
];

export const MESES = [
  { value: 1, text: "Janeiro" },
  { value: 2, text: "Fevereiro" },
  { value: 3, text: "Março" },
  { value: 4, text: "Abril" },
  { value: 5, text: "Maio" },
  { value: 6, text: "Junho" },
  { value: 7, text: "Julho" },
  { value: 8, text: "Agosto" },
  { value: 9, text: "Setembro" },
  { value: 10, text: "Outubro" },
  { value: 11, text: "Novembro" },
  { value: 12, text: "Dezembro" },
];

export const SIM_NAO = [
  { value: true, text: "Sim" },
  { value: false, text: "Não" },
];

// Tabela 06 - Países (somente os vigentes).

export const PAISES = [
  { value: "013", text: "013 - Afeganistão" },
  { value: "017", text: "017 - Albânia, República da" },
  { value: "023", text: "023 - Alemanha" },
  { value: "031", text: "031 - Burkina Faso" },
  { value: "037", text: "037 - Andorra" },
  { value: "040", text: "040 - Angola" },
  { value: "041", text: "041 - Anguilla" },
  { value: "043", text: "043 - Antígua e Barbuda" },
  { value: "053", text: "053 - Arábia Saudita" },
  { value: "059", text: "059 - Argélia" },
  { value: "063", text: "063 - Argentina" },
  { value: "064", text: "064 - Armênia, República da" },
  { value: "065", text: "065 - Aruba" },
  { value: "069", text: "069 - Austrália" },
  { value: "072", text: "072 - Áustria" },
  { value: "073", text: "073 - Azerbaijão, República do" },
  { value: "077", text: "077 - Bahamas, Ilhas" },
  { value: "080", text: "080 - Bahrein, Ilhas" },
  { value: "081", text: "081 - Bangladesh" },
  { value: "083", text: "083 - Barbados" },
  { value: "085", text: "085 - Belarus, República da" },
  { value: "087", text: "087 - Bélgica" },
  { value: "088", text: "088 - Belize" },
  { value: "090", text: "090 - Bermudas" },
  { value: "093", text: "093 - Mianmar (Birmânia)" },
  { value: "097", text: "097 - Bolívia, Estado Plurinacional da" },
  { value: "098", text: "098 - Bósnia-Herzegovina, República da" },
  { value: "099", text: "099 - Bonaire, Saint Eustatius e Saba" },
  { value: "101", text: "101 - Botsuana" },
  { value: "102", text: "102 - Bouvet, Ilha" },
  { value: "105", text: "105 - Brasil" },
  { value: "108", text: "108 - Brunei" },
  { value: "111", text: "111 - Bulgária, República da" },
  { value: "115", text: "115 - Burundi" },
  { value: "119", text: "119 - Butão" },
  { value: "127", text: "127 - Cabo Verde, República de" },
  { value: "137", text: "137 - Cayman, Ilhas" },
  { value: "141", text: "141 - Camboja" },
  { value: "145", text: "145 - Camarões" },
  { value: "149", text: "149 - Canadá" },
  { value: "153", text: "153 - Cazaquistão, República do" },
  { value: "154", text: "154 - Catar" },
  { value: "158", text: "158 - Chile" },
  { value: "160", text: "160 - China, República Popular da" },
  { value: "161", text: "161 - Formosa (Taiwan)" },
  { value: "163", text: "163 - Chipre" },
  { value: "165", text: "165 - Cocos (Keeling), Ilhas" },
  { value: "169", text: "169 - Colômbia" },
  { value: "173", text: "173 - Comores, Ilhas" },
  { value: "177", text: "177 - Congo" },
  { value: "183", text: "183 - Cook, Ilhas" },
  {
    value: "187",
    text: "187 - Coreia (do Norte), República Popular Democrática da",
  },
  { value: "190", text: "190 - Coreia (do Sul), República da" },
  { value: "193", text: "193 - Costa do Marfim" },
  { value: "195", text: "195 - Croácia, República da" },
  { value: "196", text: "196 - Costa Rica" },
  { value: "198", text: "198 - Kuwait" },
  { value: "199", text: "199 - Cuba" },
  { value: "200", text: "200 - Curaçao" },
  { value: "229", text: "229 - Benim" },
  { value: "232", text: "232 - Dinamarca" },
  { value: "235", text: "235 - Dominica, Ilha" },
  { value: "239", text: "239 - Equador" },
  { value: "240", text: "240 - Egito" },
  { value: "243", text: "243 - Eritreia" },
  { value: "244", text: "244 - Emirados Árabes Unidos" },
  { value: "245", text: "245 - Espanha" },
  { value: "246", text: "246 - Eslovênia, República da" },
  { value: "247", text: "247 - Eslovaca, República" },
  { value: "249", text: "249 - Estados Unidos" },
  { value: "251", text: "251 - Estônia, República da" },
  { value: "253", text: "253 - Etiópia" },
  { value: "255", text: "255 - Falkland (Ilhas Malvinas)" },
  { value: "259", text: "259 - Feroe, Ilhas" },
  { value: "267", text: "267 - Filipinas" },
  { value: "271", text: "271 - Finlândia" },
  { value: "275", text: "275 - França" },
  { value: "281", text: "281 - Gabão" },
  { value: "285", text: "285 - Gâmbia" },
  { value: "289", text: "289 - Gana" },
  { value: "291", text: "291 - Geórgia, República da" },
  { value: "293", text: "293 - Gibraltar" },
  { value: "297", text: "297 - Granada" },
  { value: "301", text: "301 - Grécia" },
  { value: "305", text: "305 - Groenlândia" },
  { value: "309", text: "309 - Guadalupe" },
  { value: "313", text: "313 - Guam" },
  { value: "317", text: "317 - Guatemala" },
  { value: "321", text: "321 - Guernsey, Ilha do Canal" },
  { value: "325", text: "325 - Guiana Francesa" },
  { value: "329", text: "329 - Guiné" },
  { value: "331", text: "331 - Guiné Equatorial" },
  { value: "334", text: "334 - Guiné-Bissau" },
  { value: "337", text: "337 - Guiana" },
  { value: "341", text: "341 - Haiti" },
  { value: "345", text: "345 - Honduras" },
  { value: "351", text: "351 - Hong Kong" },
  { value: "355", text: "355 - Hungria, República da" },
  { value: "357", text: "357 - Iêmen" },
  { value: "359", text: "359 - Man, Ilha de" },
  { value: "361", text: "361 - Índia" },
  { value: "365", text: "365 - Indonésia" },
  { value: "369", text: "369 - Iraque" },
  { value: "372", text: "372 - Irã, República Islâmica do" },
  { value: "375", text: "375 - Irlanda" },
  { value: "379", text: "379 - Islândia" },
  { value: "383", text: "383 - Israel" },
  { value: "386", text: "386 - Itália" },
  { value: "391", text: "391 - Jamaica" },
  { value: "393", text: "393 - Jersey, Ilha do Canal" },
  { value: "399", text: "399 - Japão" },
  { value: "403", text: "403 - Jordânia" },
  { value: "411", text: "411 - Kiribati" },
  { value: "420", text: "420 - Laos, República Popular Democrática do" },
  { value: "426", text: "426 - Lesoto" },
  { value: "427", text: "427 - Letônia, República da" },
  { value: "431", text: "431 - Líbano" },
  { value: "434", text: "434 - Libéria" },
  { value: "438", text: "438 - Líbia" },
  { value: "440", text: "440 - Liechtenstein" },
  { value: "442", text: "442 - Lituânia, República da" },
  { value: "445", text: "445 - Luxemburgo" },
  { value: "447", text: "447 - Macau" },
  { value: "449", text: "449 - Macedônia do Norte" },
  { value: "450", text: "450 - Madagascar" },
  { value: "455", text: "455 - Malásia" },
  { value: "458", text: "458 - Malavi" },
  { value: "461", text: "461 - Maldivas" },
  { value: "464", text: "464 - Mali" },
  { value: "467", text: "467 - Malta" },
  { value: "472", text: "472 - Marianas do Norte" },
  { value: "474", text: "474 - Marrocos" },
  { value: "476", text: "476 - Marshall, Ilhas" },
  { value: "477", text: "477 - Martinica" },
  { value: "485", text: "485 - Maurício" },
  { value: "488", text: "488 - Mauritânia" },
  { value: "493", text: "493 - México" },
  { value: "494", text: "494 - Moldávia, República da" },
  { value: "495", text: "495 - Mônaco" },
  { value: "497", text: "497 - Mongólia" },
  { value: "498", text: "498 - Montenegro" },
  { value: "499", text: "499 - Micronésia" },
  { value: "501", text: "501 - Montserrat, Ilhas" },
  { value: "505", text: "505 - Moçambique" },
  { value: "507", text: "507 - Namíbia" },
  { value: "508", text: "508 - Nauru" },
  { value: "511", text: "511 - Christmas, Ilha (Navidad)" },
  { value: "517", text: "517 - Nepal" },
  { value: "521", text: "521 - Nicarágua" },
  { value: "525", text: "525 - Níger" },
  { value: "528", text: "528 - Nigéria" },
  { value: "531", text: "531 - Niue, Ilha" },
  { value: "535", text: "535 - Norfolk, Ilha" },
  { value: "538", text: "538 - Noruega" },
  { value: "542", text: "542 - Nova Caledônia" },
  { value: "545", text: "545 - Papua Nova Guiné" },
  { value: "548", text: "548 - Nova Zelândia" },
  { value: "551", text: "551 - Vanuatu" },
  { value: "556", text: "556 - Omã" },
  { value: "566", text: "566 - Pacífico, Ilhas do (Possessão dos EUA)" },
  { value: "573", text: "573 - Países Baixos (Holanda)" },
  { value: "575", text: "575 - Palau" },
  { value: "576", text: "576 - Paquistão" },
  { value: "578", text: "578 - Palestina" },
  { value: "580", text: "580 - Panamá" },
  { value: "586", text: "586 - Paraguai" },
  { value: "589", text: "589 - Peru" },
  { value: "593", text: "593 - Pitcairn, Ilha" },
  { value: "599", text: "599 - Polinésia Francesa" },
  { value: "603", text: "603 - Polônia, República da" },
  { value: "607", text: "607 - Portugal" },
  { value: "611", text: "611 - Porto Rico" },
  { value: "623", text: "623 - Quênia" },
  { value: "625", text: "625 - Quirguiz, República" },
  { value: "628", text: "628 - Reino Unido" },
  { value: "640", text: "640 - República Centro-Africana" },
  { value: "647", text: "647 - República Dominicana" },
  { value: "660", text: "660 - Reunião, Ilha" },
  { value: "665", text: "665 - Zimbábue" },
  { value: "670", text: "670 - Romênia" },
  { value: "675", text: "675 - Ruanda" },
  { value: "676", text: "676 - Rússia, Federação da" },
  { value: "677", text: "677 - Salomão, Ilhas" },
  { value: "685", text: "685 - Saara Ocidental" },
  { value: "687", text: "687 - El Salvador" },
  { value: "690", text: "690 - Samoa" },
  { value: "691", text: "691 - Samoa Americana" },
  { value: "695", text: "695 - São Cristóvão e Neves, Ilhas" },
  { value: "697", text: "697 - San Marino" },
  { value: "698", text: "698 - São Martinho, Ilha de (Parte Francesa)" },
  { value: "699", text: "699 - São Martinho, Ilha de (Parte Holandesa)" },
  { value: "700", text: "700 - São Pedro e Miquelon" },
  { value: "705", text: "705 - São Vicente e Granadinas" },
  { value: "710", text: "710 - Santa Helena" },
  { value: "715", text: "715 - Santa Lúcia" },
  { value: "720", text: "720 - São Tomé e Príncipe, Ilhas" },
  { value: "728", text: "728 - Senegal" },
  { value: "731", text: "731 - Seychelles" },
  { value: "735", text: "735 - Serra Leoa" },
  { value: "737", text: "737 - Sérvia" },
  { value: "741", text: "741 - Singapura" },
  { value: "744", text: "744 - Síria, República Árabe da" },
  { value: "748", text: "748 - Somália" },
  { value: "750", text: "750 - Sri Lanka" },
  { value: "754", text: "754 - eSwatini (Essuatíni, Suazilândia)" },
  { value: "755", text: "755 - Svalbard e Jan Mayen" },
  { value: "756", text: "756 - África do Sul" },
  { value: "759", text: "759 - Sudão" },
  { value: "760", text: "760 - Sudão do Sul" },
  { value: "764", text: "764 - Suécia" },
  { value: "767", text: "767 - Suíça" },
  { value: "770", text: "770 - Suriname" },
  { value: "772", text: "772 - Tadjiquistão, República do" },
  { value: "776", text: "776 - Tailândia" },
  { value: "780", text: "780 - Tanzânia, República Unida da" },
  { value: "782", text: "782 - Território Britânico Oceano Índico" },
  { value: "783", text: "783 - Djibuti" },
  { value: "788", text: "788 - Chade" },
  { value: "791", text: "791 - Tcheca, República" },
  { value: "795", text: "795 - Timor Leste" },
  { value: "800", text: "800 - Togo" },
  { value: "805", text: "805 - Toquelau, Ilhas" },
  { value: "810", text: "810 - Tonga" },
  { value: "815", text: "815 - Trinidad e Tobago" },
  { value: "820", text: "820 - Tunísia" },
  { value: "823", text: "823 - Turcas e Caicos, Ilhas" },
  { value: "824", text: "824 - Turcomenistão, República do" },
  { value: "827", text: "827 - Turquia" },
  { value: "828", text: "828 - Tuvalu" },
  { value: "831", text: "831 - Ucrânia" },
  { value: "833", text: "833 - Uganda" },
  { value: "845", text: "845 - Uruguai" },
  { value: "847", text: "847 - Uzbequistão, República do" },
  { value: "848", text: "848 - Vaticano, Estado da Cidade do" },
  { value: "850", text: "850 - Venezuela" },
  { value: "858", text: "858 - Vietnã" },
  { value: "863", text: "863 - Virgens, Ilhas (Britânicas)" },
  { value: "866", text: "866 - Virgens, Ilhas (EUA)" },
  { value: "870", text: "870 - Fiji" },
  { value: "875", text: "875 - Wallis e Futuna, Ilhas" },
  { value: "888", text: "888 - Congo, República Democrática do" },
  { value: "890", text: "890 - Zâmbia" },
];

// Tabela 08 - Classificação tributária (S-1000).

export const CLASSIFICACOES_TRIBUTARIAS = [
  {
    value: "01",
    text: "01 - Simples Nacional com tributação previdenciária substituída",
  },
  {
    value: "02",
    text: "02 - Simples Nacional com tributação previdenciária não substituída",
  },
  {
    value: "03",
    text: "03 - Simples Nacional com tributação previdenciária substituída e não substituída",
  },
  { value: "04", text: "04 - MEI - Microempreendedor Individual" },
  { value: "06", text: "06 - Agroindústria" },
  { value: "07", text: "07 - Produtor rural pessoa jurídica" },
  { value: "09", text: "09 - Órgão Gestor de Mão de Obra" },
  {
    value: "10",
    text: "10 - Entidade sindical a que se refere a Lei 12.023/2009",
  },
  {
    value: "11",
    text: "11 - Associação desportiva que mantém clube de futebol profissional",
  },
  {
    value: "13",
    text: "13 - Banco, caixa econômica, sociedade de crédito e demais do art. 22, § 1º, da Lei 8.212/1991",
  },
  { value: "14", text: "14 - Sindicatos em geral, exceto os do código 10" },
  { value: "21", text: "21 - Pessoa física, exceto segurado especial" },
  {
    value: "22",
    text: "22 - Segurado especial, inclusive quando for empregador doméstico",
  },
  {
    value: "60",
    text: "60 - Missão diplomática ou repartição consular de carreira estrangeira",
  },
  { value: "70", text: "70 - Empresa de que trata o Decreto 5.436/2005" },
  {
    value: "80",
    text: "80 - Entidade beneficente/isenta de contribuições sociais",
  },
  {
    value: "85",
    text: "85 - Administração direta, autarquias e fundações públicas",
  },
  { value: "99", text: "99 - Pessoas jurídicas em geral" },
];

export const INDICATIVOS_COOPERATIVA = [
  { value: 0, text: "Não é cooperativa" },
  { value: 1, text: "Cooperativa de trabalho" },
  { value: 2, text: "Cooperativa de produção" },
  { value: 3, text: "Outras cooperativas" },
];

export const INDICATIVOS_DESONERACAO = [
  { value: 0, text: "Não aplicável" },
  { value: 1, text: "Empresa enquadrada na desoneração da folha" },
  { value: 2, text: "Município enquadrado na legislação vigente" },
];

export const OPCOES_PRODUTOR_RURAL = [
  { value: 1, text: "Contribuição sobre a comercialização da produção" },
  { value: 2, text: "Contribuição sobre a folha de pagamento" },
];

export const TIPOS_CAEPF = [
  { value: 1, text: "Contribuinte individual" },
  { value: 2, text: "Produtor rural" },
  { value: 3, text: "Segurado especial" },
];

export const SUBSTITUICOES_OBRA = [
  { value: 1, text: "Contribuição patronal substituída" },
  { value: 2, text: "Contribuição patronal não substituída" },
];

export const TIPOS_INSCRICAO_LOTACAO = [
  { value: 1, text: "CNPJ" },
  { value: 2, text: "CPF" },
  { value: 4, text: "CNO" },
];

// Tabela 10 - Tipos de lotação tributária (S-1020).

export const TIPOS_LOTACAO = [
  {
    value: "01",
    text: "01 - Atividade econômica da empresa (FPAS), inclusive obra própria",
  },
  {
    value: "02",
    text: "02 - Obra de construção civil - empreitada parcial ou subempreitada",
  },
  { value: "03", text: "03 - Pessoa física tomadora de cessão de mão de obra" },
  {
    value: "04",
    text: "04 - Pessoa jurídica tomadora de cessão de mão de obra",
  },
  {
    value: "05",
    text: "05 - Pessoa jurídica tomadora de serviços de cooperativa de trabalho",
  },
  {
    value: "06",
    text: "06 - Entidade beneficente/isenta tomadora de serviços de cooperativa de trabalho",
  },
  {
    value: "07",
    text: "07 - Pessoa física tomadora de serviços de cooperativa de trabalho",
  },
  {
    value: "08",
    text: "08 - Operador portuário tomador de trabalhadores avulsos",
  },
  {
    value: "09",
    text: "09 - Contratante de avulsos não portuários por intermédio de sindicato",
  },
  {
    value: "10",
    text: "10 - Embarcação inscrita no Registro Especial Brasileiro (REB)",
  },
  {
    value: "21",
    text: "21 - Atividade econômica ou obra própria da pessoa física",
  },
  { value: "24", text: "24 - Empregador doméstico" },
  {
    value: "90",
    text: "90 - Atividades no exterior por trabalhador vinculado ao RGPS (expatriados)",
  },
  {
    value: "91",
    text: "91 - Trabalhador estrangeiro vinculado a regime de previdência estrangeiro",
  },
  {
    value: "92",
    text: "92 - Bolsista contribuinte individual sem contribuição patronal",
  },
];

export const LOTACOES_SEM_INSCRICAO = [
  "01",
  "10",
  "21",
  "24",
  "90",
  "91",
  "92",
];

// Tabela 04 - FPAS, com o código de terceiros usual de cada um (confira o enquadramento da empresa).

export const FPAS = [
  [507, "0079"],
  [515, "0115"],
  [523, "0003"],
  [531, "0003"],
  [540, "0131"],
  [558, "0259"],
  [566, "0099"],
  [574, "0099"],
  [582, "0000"],
  [590, "0000"],
  [604, "0003"],
  [612, "3139"],
  [620, "3072"],
  [639, "0000"],
  [647, "0099"],
  [655, "0001"],
  [680, "0131"],
  [736, "0003"],
  [744, "0512"],
  [779, "0000"],
  [787, "0515"],
  [795, "4099"],
  [825, "0003"],
  [833, "0079"],
  [868, "0000"],
  [876, "0000"],
].map(([value, terceiros]) => ({
  value,
  terceiros,
  text: `${value} (terceiros usual ${terceiros})`,
}));

export function descricao(tabela, valor) {
  const item = tabela.find((i) => i.value === valor);
  return item ? item.text : valor == null ? "-" : String(valor);
}
